module.exports = __webpack_public_path__ + "media/customizations/mywilloway/logo-19cffa4f3f48ead493fc4440215ede1c.png";